import { gql } from "@apollo/client";

export const GetGogasUsers = gql`
query GetGogasUserProfile($_eq: String = "") {
  gogas_user_profile(where: {phone_number: {_eq: $_eq}}) {
    gogas_wallets {
      balance
    }
    id
    name
    phone_number
  }
}
`;